import { format } from 'date-fns'

export type PaginationRequestParams = {
  offset?: number,
  page_size?: number,
  page?: number,
}

export type TrainingDiariesParams = {
  date?: Date,
  days?: number
}


export function castTrainingParams (params: TrainingDiariesParams) {
  return {
    date: params.date ? format(params.date, 'dd-MM-yyyy') : undefined,
    days: params.days,
  }
}
